import { render, staticRenderFns } from "./blockTwo.vue?vue&type=template&id=4993a718&scoped=true"
import script from "./blockTwo.vue?vue&type=script&lang=js"
export * from "./blockTwo.vue?vue&type=script&lang=js"
import style0 from "./blockTwo.vue?vue&type=style&index=0&id=4993a718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993a718",
  null
  
)

export default component.exports